import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import {cloneDeep} from 'lodash'

const defaultAdObject = {
  id: 0,
  name: 'Ad 1',
  url: '',
  content: '',
  has_phone: false,
  phone_type: 'whatsapp', // phone, whatsapp
  country_code: 'EG',
  phone_number: null,
  file: null,
  has_video: false,
  is_story: false,
  story_type: null,
  upload_video: false,
  upload_enabled: true,
  hasError: false,
  is_previewing: false,
  activation_status: null,
  acceptance_status: null,
  impressions_tracker: [
    {
      type: 'url',
      value: null
    }
  ],
  audience_suggestions: {
    genders: [],
    age_groups: []
  },
  show_audience_suggestions: true,
  review_reasons: [],
  want_to_update: false,
  comment: null // this will be used as rejection and hold note
}

const state = {
  budgetActionTypes: [
    {
      id: 'Lead',
      label: 'Lead'
    },
    {
      id: 'Signup',
      label: 'Signup'
    },
    {
      id: 'Add to cart',
      label: 'Add to cart'
    },
    {
      id: 'Add to wish list',
      label: 'Add to wish list'
    },
    {
      id: 'Purchase',
      label: 'Purchase'
    }
  ],
  pixelEvents: [
    {
      id: 'total',
      label: 'Conversions'
    },
    {
      id: 'leads',
      label: 'Leads'
    },
    {
      id: 'install',
      label: 'App Installs'
    },
    {
      id: 'add_to_wishlist',
      label: 'Add To Wishlist'
    },
    {
      id: 'add_to_cart',
      label: 'Add To Cart'
    },
    {
      id: 'sign_up',
      label: 'Sign Up'
    },
    {
      id: 'purchase',
      label: 'Purchase'
    }
  ],
  campaignCategories: [],
  advertisingChannels: [],
  objectives: [],
  types: [],
  rejectReviewReasons: [],
  genders: [],
  ageGroups: [],
  targetDevices: [],
  holdReviewReasons: [],
  defaultAdObject: cloneDeep(defaultAdObject),
  defaultAdsetObject: {
    id: 0,
    name: 'Ad Set 1',
    language: 2,
    new_audience: true,
    new_audience_name: '', // The audience naming shall be unique per logging in account
    content_categories: [],
    locations: {
      countries: [],
      cities: []
    },
    isps: [],
    keywords: [],
    target_devices: [
      1,
      2,
      3
    ],
    target_platforms: {
      websites: [],
      apps: [],
      purgeable_disallowed_domains_history: [],
      include_new_platforms: true
    },
    meta_detailed_targeting: [],
    target_genders: [],
    target_age_range: [18, 65],
    delivery_type : '1',
    budget: {
      optimizing_for: null, // impressions, clicks, videos, actions
      action_type: 'Lead', // Lead, Signup, Add to cart, Add to wish list, Purchase
      cost_per_action: null,
      fallback_cpc: null,
      budget_value: null,
      /**
       * {
       *     id: item.id, // domain id
       *     bid: item.minbid // custom bid
       * }
       */
      custom_bids: []
    },
    frequency_capping: 0,
    // audience_id: 0,
    hasError: false,
    is_duplicating: false,
    ads: [cloneDeep(defaultAdObject)]
  },
  deletedCampaign: null,
  loggedInAccountCampaigns: [],
  targeting_lookups: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
